<span>
  @for (brwtype of knownBrowserTypes; track brwtype; let last = $last; let first = $first) {
    <span>
      <span class="wm-m-browsersinfo" [ngClass]="{'multiline': multiline, 'first': first, 'last': last}">
        <!-- TODO: replace Archetype with AssetAndBlobService Call -->
        @if (browserTypeImages[brwtype] !== undefined) {
          <img class="wm-m-browserinfo-browserlogo" [src]="browserTypeImages[brwtype]" onError="this.src='/assets/img/questionmark.png'" pTooltip="{{brwtype.charAt(0).toUpperCase() + brwtype.slice(1)}}" tooltipPosition="right"/>
        }
        @if (browserTypeImages[brwtype] === undefined) {
          <img class="wm-m-browserinfo-browserlogo" src="/assets/img/questionmark.png" pTooltip="{{brwtype.charAt(0).toUpperCase() + brwtype.slice(1)}}" tooltipPosition="right"/>
        }
        <span class="wm-m-browsersinfo-versions">{{aggregatedVersionStrings[brwtype]}}</span>
      </span>
    </span>
  }
</span>
